import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import Home from './components/Home'
import Locations from './components/Locations'
import Pricing from './components/Pricing'
import Events from './components/Events/Events'
import Groups from './components/Groups'
import Other from './components/Other'
import Contact from './components/Contact'
import GroupContact from './components/GroupContact'
import ClarkPark from './components/Locations/ClarkPark'
import Busse from './components/Locations/Busse'
import Maple from './components/Locations/Maple'
import Skokie from './components/Locations/Skokie'
import LakeTampier from './components/Locations/LakeTampier'
import Employment from './components/Other/Employment'
import Faq from './components/Other/Faq'
import Gift from './components/Other/Gift'
import Links from './components/Other/Links'
import Used from './components/Other/Used'
import Waiver from './components/Other/Waiver'
import Exercise from './components/Events/Exercise'
import Marathon from './components/Events/Marathon'
import Twilight from './components/Events/Twilight'
import FreeCanoeAndKayakEvents from './components/Events/FreeCanoeAndKayakEvents'
// import Boats from './components/Boats'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue);

const routes = [
  { path: '', component: Home },
  { path: '/Locations', component: Locations },
  { path: '/Pricing', component: Pricing },
  { path: '/Events', component: Events },
  { path: '/Groups', component: Groups },
  { path: '/Other', component: Other },
  { path: '/Contact', component: Contact },
  { path: '/GroupContact', component: GroupContact },
  { path: '/ClarkPark', component: ClarkPark },
  { path: '/Busse', component: Busse },
  { path: '/Maple', component: Maple },
  { path: '/Skokie', component: Skokie },
  { path: '/LakeTampier', component: LakeTampier },
  { path: '', component: Other },
  { path: '/Employment', component: Employment },
  { path: '/Links', component: Links },
  { path: '/Used', component: Used },
  { path: '/FAQ', component: Faq },
  { path: '/Gift', component: Gift },
  { path: '/Waiver', component: Waiver },
  { path: '/Exercise', component: Exercise },
  { path: '/Marathon', component: Marathon },
  { path: '/Twilight', component: Twilight },
  { path: '/FreeCanoeAndKayakEvents', component: FreeCanoeAndKayakEvents },

  // { path: '/Boats', component: Boats },
]
const router = new VueRouter({
  routes // short for `routes: routes`
})
Vue.use(VueRouter);

Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
